import React, { useEffect, useState } from 'react'
import BusHeader from './BusHeader'
import Nav from '../master/NavBar'
import Header from '../master/SideBar'
import { closeModal, ToastMain ,SweetAlertShow} from '../master/Master'
import { BusRoute, BusStudentCreate, GetBus, GetBusStudent } from '../../api/BusService'
import { student } from '../../api/StudentServices'
import { viewlist } from '../../api/BatchService'

const AdmitStudentBus = () => {
    const [loading, setLoading] = useState(false);
      const [batches, setBatches] = useState([]);
      const [studentlist, setStudentlist] = useState([]);
      const [routes, setRoutes] = useState([]);
      const [buses, setBuses] = useState([]);
      const [BusStudent, setBusStudent] = useState([]);
      const [searchBusId, setsearchBusId] = useState("");
      const [selectedRouteId, setSelectedRouteId] = useState("");
      const [busFees, setBusFees] = useState("");
      const [busFinalFees, setBusFinalFees] = useState("");
      const [busDiscount, setBusDiscount] = useState("");
      const [SelectedBusId, setSelectedBusId] = useState('')
      const [batchId, setBatchId] = useState('')
      const [error, setError] = useState('')
    
      const getBatchList = async () => {
        try {
          const response = await viewlist();
          setBatches(response.data?.batches || []);
        } catch (error) {
          SweetAlertShow('error','Error',error?.response?.data?.message ?? error?.response?.message ?? error?.message)
          // ToastMain.fire({
          //   icon: "error",
          //   title:
          //     error?.response?.data?.message ||
          //     error?.response?.message ||
          //     "Something Want Wrong!",
          // });
        }
      };
    
        useEffect(() => {
      
          getBatchList();
        }, []);
      const busList = async () => {
        // let addUrl = `&id=${SelectedBusId}`;
        setLoading(true);
        try {
          const response = await GetBus();
          if (response.data) {
            setBuses(response?.data?.data);
          } else {
            SweetAlertShow('info','Warning',response?.data?.message)
            // ToastMain.fire({
            //   icon: "info",
            //   title: response?.data?.message || "Something Want Wrong!",
            // });
          }
        } catch (error) {
          SweetAlertShow('error','Error',error?.response?.data?.message ?? error?.response?.message ?? error?.message)
          // ToastMain.fire({
          //   icon: "error",
          //   title:
          //     error?.response?.data?.message ||
          //     error?.response?.message ||
          //     "Something Want Wrong!",
          // });
        } finally {
          setLoading(false);
        }
      };
      const studentList = async () => {
        let addUrl = `&bus_id=${SelectedBusId}`;
        setLoading(true);
        try {
          const response = await GetBusStudent(addUrl);
          if (response.data) {
            setBusStudent(response?.data?.data?.data || []); // directly students array set kar do
          } else {
            SweetAlertShow('info','Warning',response?.data?.message)
            // ToastMain.fire({
            //   icon: "info",
            //   title: response?.data?.message || "Something Went Wrong!",
            // });
          }
        } catch (error) {
          SweetAlertShow('error','Error',error?.response?.data?.message ?? error?.response?.message ?? error?.message)
          // ToastMain.fire({
          //   icon: "error",
          //   title:
          //     error?.response?.data?.message ||
          //     error?.response?.message ||
          //     "Something Went Wrong!",
          // });
        } finally {
          setLoading(false);
        }
      };
    
    
      // useEffect(() => {
      //   busList();
      // }, []);
      useEffect(() => {
        busList();
      }, []);
      useEffect(() => {
        studentList();
      }, [SelectedBusId]);
    
    
      const fetchStudentsByBatch = async () => {
        let addUrl = `&batch_id=${batchId}`;
        try {
          const response = await student(addUrl);
          const allStudents = response?.data?.data?.data || [];
          setStudentlist(allStudents);
        } catch (error) {
          SweetAlertShow('error','Error',error?.response?.data?.message ??  error?.response?.message ?? error?.message)
          // ToastMain.fire({
          //   icon: "error",
          //   title:
          //     error?.response?.data?.message ||
          //     error?.response?.message ||
          //     "Something Want Wrong!",
          // });
        }
      };
    
      useEffect(() => {
        if (batchId) {
          fetchStudentsByBatch();
        }
      }, [batchId]);
    
    
      const handleBusChange = async (busId) => {
        setsearchBusId(busId);
        setRoutes([]);
        setSelectedRouteId("");
        setBusFees("");
        setBusFinalFees("");
        setBusDiscount("");
    
        try {
          const res = await BusRoute(busId);
          let routeList = res?.data?.data?.data || res?.data?.data || [];
    
          if (!Array.isArray(routeList)) {
            routeList = [routeList];
          }
    
          setRoutes(routeList);
    
          if (routeList.length > 0) {
            setSelectedRouteId(routeList[0].id.toString());
            setBusFees(routeList[0].route_fee || "");
          }
        } catch (error) {

          SweetAlertShow('error','Error',error?.response?.data?.message ?? error?.response?.message ?? error?.message)
          // ToastMain.fire({
          //   icon: "error",
          //   title:
          //     error?.response?.data?.message ||
          //     error?.response?.message ||
          //     "Something Want Wrong!",
          // });
        }
      };
    
      const handleRouteChange = (routeId) => {
        setSelectedRouteId(routeId);
        const selected = routes.find(
          (route) => route.id.toString() === routeId.toString()
        );
        setBusFees(selected?.route_fee || "");
      };
    
      useEffect(() => {
        const bus = parseFloat(busFees) || 0;
        const final = parseFloat(busFinalFees) || 0;
        if (final < bus) {
          setBusDiscount((bus - final).toFixed(2));
        } else {
          setBusDiscount("0");
        }
      }, [busFinalFees, busFees]);
    
    
      const Addstudent = async (e) => {
        e.preventDefault();
        try {
          const formData = new FormData(e.target);
          formData.set("bus_discount", busDiscount);
          const data = Object.fromEntries(formData.entries());
          const response = await BusStudentCreate(data);
    
          if (response?.data?.status) {
            setError('')
            closeModal("addinbus")
            busList();
            SweetAlertShow('success','Successfully',response?.data?.message)
            // ToastMain.fire({
            //   icon: "success",
            //   title: "Student Successfully Added",
            // })
          } else {
            if (response?.data?.errors) {
              setError(response?.data?.errors)
            }
            SweetAlertShow('info','Warning',response?.data?.message)
            // ToastMain.fire({
            //   icon: 'info',
            //   title: response?.data?.message || 'something went wrong'
            // })
          }
        } catch (error) {
          if (error?.response?.data?.errors) {
            setError(error?.response?.data?.errors)
          }
          SweetAlertShow('error','Error',error?.response?.data?.message ??  error?.response?.message ?? error?.message)
          // ToastMain.fire({
          //   icon: "error",
          //   title:
          //     error?.response?.data?.message ||
          //     error?.response?.message ||
          //     "Something Went Wrong!",
          // });
        }
      };
    return (
        <>
            {loading && (
                <div
                    className="d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100"
                    style={{ zIndex: 9999 }}
                >
                    <div className="sk-chase sk-primary display-1">
                        <div className="sk-chase-dot" />
                        <div className="sk-chase-dot" />
                        <div className="sk-chase-dot" />
                        <div className="sk-chase-dot" />
                        <div className="sk-chase-dot" />
                        <div className="sk-chase-dot" />
                    </div>
                </div>
            )}

            <div className="layout-wrapper layout-content-navbar">
                <div className="layout-container">
                    <Header />
                    <div className="layout-page">
                        <Nav />
                        <div className="content-wrapper">
                            <div className="container-fluid mt-2">

                                <div className="row">
                                    <div className="d-flex gap-2">
                                        <div className="col-md-3">
                                            <BusHeader data={'Bus Portal'} />
                                        </div>
                                        <div className="col-md-9">
                                            <div className="card">
                                                <div className="card-body">
                                                    <form onSubmit={Addstudent}>
                                                        <h5 className='text-primary'>Add Student</h5>
                                                        <div className="modal-body">
                                                            <div className="row">
                                                                {/* Batch */}
                                                                <div className="mb-3 col-md-6 form-floating form-floating-outline">

                                                                    <select
                                                                        name="batch_id"
                                                                        className="form-control"
                                                                        value={batchId}
                                                                        onChange={(e) => {
                                                                            setBatchId(e.target.value);
                                                                        }}
                                                                    >
                                                                        <option value="">Select Batch</option>
                                                                        {batches.map((batch) => (
                                                                            <option key={batch.id} value={batch.id}>
                                                                                {batch.title}({batch.id})
                                                                            </option>
                                                                        ))}
                                                                    </select>
                                                                    <label>Select Batch</label>
                                                                    <span className="text-danger">{error?.batch_id ?? ''}</span>
                                                                </div>

                                                                {/* Student */}
                                                                <div className="mb-3 col-md-6 form-floating form-floating-outline">

                                                                    <select
                                                                        name="student_id"
                                                                        className="form-control"

                                                                    >
                                                                        <option value="">Select Student</option>
                                                                        {studentlist?.map((student) => (
                                                                            <option key={student.id} value={student.id}>
                                                                                {student.name}
                                                                            </option>
                                                                        ))}
                                                                    </select>
                                                                    <label>Select Student</label>
                                                                    <span className="text-danger">{error?.student_id ?? ''}</span>

                                                                </div>

                                                                {/* Bus */}
                                                                <div className="mb-3 col-md-6 form-floating form-floating-outline">

                                                                    <select
                                                                        name="bus_id"
                                                                        className="form-control"
                                                                        value={searchBusId}
                                                                        onChange={(e) => handleBusChange(e.target.value)}
                                                                    >
                                                                        <option value="">Select Bus</option>
                                                                        {buses.map((bus) => (
                                                                            <option key={bus.id} value={bus.id}>
                                                                                {bus.bus_number}
                                                                            </option>
                                                                        ))}
                                                                    </select>
                                                                    <label>Select Bus</label>
                                                                    <span className="text-danger">{error?.bus_id ?? ''}</span>

                                                                </div>

                                                                {/* Route */}
                                                                <div className="mb-3 col-md-6 form-floating form-floating-outline">

                                                                    <select
                                                                        name="route_id"
                                                                        className="form-control"
                                                                        value={selectedRouteId}
                                                                        onChange={(e) =>
                                                                            handleRouteChange(e.target.value)
                                                                        }
                                                                    >
                                                                        <option value="">Select Route</option>
                                                                        {Array.isArray(routes) && routes.length > 0 ? (
                                                                            routes.map((route) => (
                                                                                <option key={route.id} value={route.id}>
                                                                                    {route.route_name}
                                                                                </option>
                                                                            ))
                                                                        ) : (
                                                                            <option disabled>No routes found</option>
                                                                        )}
                                                                    </select>
                                                                    <label>Select Route</label>
                                                                    <span className="text-danger">{error?.route_id ?? ''}</span>

                                                                </div>

                                                                {/* Bus Fees */}
                                                                <div className="mb-3 col-md-6 form-floating form-floating-outline">

                                                                    <input
                                                                        type="text"
                                                                        name="bus_fees"
                                                                        className="form-control"
                                                                        value={busFees}
                                                                        readOnly
                                                                    />
                                                                    <label>Bus Fees</label>
                                                                    <span className="text-danger">{error?.bus_fees ?? ''}</span>

                                                                </div>

                                                                {/* Final Fees */}
                                                                <div className="mb-3 col-md-6 form-floating form-floating-outline">

                                                                    <input
                                                                        type="number"
                                                                        name="bus_final_fees"
                                                                        className="form-control"
                                                                        value={busFinalFees}
                                                                        onChange={(e) => setBusFinalFees(e.target.value)}
                                                                    />
                                                                    <label>Final Fees</label>
                                                                    <span className="text-danger">{error?.bus_final_fees ?? ''}</span>

                                                                </div>

                                                                {/* Discount */}
                                                                <div className="mb-3 col-md-6 form-floating form-floating-outline">

                                                                    <input
                                                                        type="text"
                                                                        name="bus_discount"
                                                                        className="form-control"
                                                                        value={busDiscount}
                                                                        readOnly
                                                                    />
                                                                    <label>Discount</label>
                                                                    <span className="text-danger">{error?.bus_discount ?? ''}</span>

                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="modal-footer">
                                                          
                                                            <button
                                                                type="submit"
                                                                className="btn btn-primary px-5"
                                                                disabled={loading}  // Disable the button while loading
                                                            >
                                                                {loading ? (
                                                                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                                ) : (
                                                                    'Submit'
                                                                )}
                                                                {loading ? ' Submitting...' : ''}
                                                            </button>
                                                        </div>
                                                    </form>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default AdmitStudentBus
